import { ArrowLeft, ShieldCheck } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { Brand } from "../components/Brand";

const copy = {
  "/privacy": {
    title: "Política de Privacidade — rascunho",
    intro:
      "Este texto é um rascunho funcional para o MVP e deve ser revisado por assessoria jurídica antes do lançamento público.",
    sections: [
      [
        "Dados tratados",
        "Contas administrativas, configurações dos projetos, conteúdo enviado, conversas do widget, avaliações e telemetria operacional mínima.",
      ],
      [
        "Finalidades",
        "Autenticar usuários do painel, operar o assistente, apoiar a revisão manual das respostas, proteger a plataforma, medir consumo e prestar suporte.",
      ],
      [
        "Isolamento",
        "Workspaces e projetos são isolados por políticas no banco. O widget acessa dados apenas por funções de backend após validação da identidade assinada.",
      ],
      [
        "Retenção e direitos",
        "Minha conta permite exportar perfil e vínculos pessoais e solicitar exclusão. Dados compartilhados exigem revisão de propriedade. O registro de uso do trial, backups e prazos de retenção precisam de política aprovada e revisão jurídica; não prometemos eliminação imediata. Contato: suporte@4apex.chat.",
      ],
    ],
  },
  "/terms": {
    title: "Termos de Uso — rascunho",
    intro:
      "Os termos abaixo descrevem o comportamento pretendido do produto. Não constituem versão jurídica final.",
    sections: [
      [
        "Uso do serviço",
        "O cliente é responsável pelo conteúdo da base, pelas origens cadastradas e pela legitimidade dos dados enviados pelo sistema hospedeiro.",
      ],
      [
        "IA e fontes",
        "Respostas podem conter erros. Fontes e avisos de confiança devem permanecer visíveis quando decisões relevantes dependem do conteúdo.",
      ],
      [
        "Trial e cobrança",
        "O teste vigente dura 7 dias, com 1 projeto e 1 instalação por projeto, sujeito à elegibilidade da conta. Ao término, o acesso operacional é pausado. Contratação online indisponível; continuidade pelo suporte@4apex.chat, sem extensão automática.",
      ],
      [
        "Segurança",
        "É proibido expor chaves secretas no snippet, manipular isolamento de outros clientes ou usar o serviço para conteúdo ilegal.",
      ],
    ],
  },
  "/security": {
    title: "Segurança por arquitetura",
    intro:
      "A identidade do widget não é confiada ao JavaScript. Projeto, tenant e usuário vêm de uma asserção curta, assinada pelo backend da aplicação.",
    sections: [
      [
        "Duas identidades",
        "Supabase Auth protege o painel. Usuários finais do APEX usam uma sessão federada, opaca e curta; nunca recebem acesso direto às tabelas.",
      ],
      [
        "Acesso por papel",
        "Toda tabela multi-tenant usa workspace_id e project_id, políticas RLS e funções privadas para verificação de papéis.",
      ],
      [
        "APEX",
        "A Página 0 renderiza apenas em página normal, autenticada e não pública. Modal, drawer e iframe também são bloqueados como defesa adicional.",
      ],
      [
        "Segredos",
        "Segredos não fazem parte do bundle nem do snippet. Credenciais próprias são informadas por administradores no painel e enviadas ao cofre; não são devolvidas após salvar. Assinatura do APEX e credenciais de serviço ficam no servidor.",
      ],
    ],
  },
};

export function LegalPage() {
  const location = useLocation();
  const page = copy[location.pathname as keyof typeof copy] || copy["/privacy"];

  return (
    <div className="legal-page">
      <header>
        <Brand />
        <Link to="/">
          <ArrowLeft size={16} /> Voltar
        </Link>
      </header>
      <main>
        <ShieldCheck />
        <h1>{page.title}</h1>
        <p className="legal-page__intro">{page.intro}</p>
        {page.sections.map(([title, body]) => (
          <section key={title}>
            <h2>{title}</h2>
            <p>{body}</p>
          </section>
        ))}
      </main>
    </div>
  );
}
